import type { AmhsStreamRunRequest } from '../../types/amhsStream';
import { resolveSimSpeed } from './scaleAmhsWallTimes';

function scaleWaitSec(value: number, factor: number): number {
  return Number.isFinite(value) ? value * factor : value;
}

function scaleAmhsStreamWaitTimes(
  request: AmhsStreamRunRequest,
  factor: number
): AmhsStreamRunRequest {
  return {
    ...request,
    handling: {
      ...request.handling,
      dropToPickSec: scaleWaitSec(request.handling.dropToPickSec, factor),
    },
    toolProcessWaitSec: scaleWaitSec(request.toolProcessWaitSec, factor),
    tools: {
      tools: request.tools.tools.map((tool) => ({
        ...tool,
        processWaitSec: scaleWaitSec(tool.processWaitSec, factor),
      })),
    },
    stockers: {
      stockers: request.stockers.stockers.map((stocker) => ({
        ...stocker,
        processWaitSec: scaleWaitSec(stocker.processWaitSec, factor),
      })),
    },
    trackNetwork: {
      ...request.trackNetwork,
      trackNetwork: {
        ...request.trackNetwork.trackNetwork,
        junctions: request.trackNetwork.trackNetwork.junctions.map((junction) => ({
          ...junction,
          waitSec: scaleWaitSec(junction.waitSec, factor),
        })),
      },
    },
  };
}

/**
 * UI / layout values for drop-to-pick, junction wait, tool process, and
 * stocker wait are wall (real) seconds. The live DES expects sim seconds.
 * Wire value = wall seconds × simSpeed.
 */
export function toAmhsStreamWireRequest(request: AmhsStreamRunRequest): AmhsStreamRunRequest {
  return scaleAmhsStreamWaitTimes(request, resolveSimSpeed(request.liveStream.simSpeed));
}

/** Inverse of {@link toAmhsStreamWireRequest} for review-JSON round trips. */
export function fromAmhsStreamWireRequest(request: AmhsStreamRunRequest): AmhsStreamRunRequest {
  return scaleAmhsStreamWaitTimes(request, 1 / resolveSimSpeed(request.liveStream.simSpeed));
}
